import { render, staticRenderFns } from "./YamoriModal.vue?vue&type=template&id=2b931f17&"
import script from "./YamoriModal.vue?vue&type=script&lang=js&"
export * from "./YamoriModal.vue?vue&type=script&lang=js&"
import style0 from "./YamoriModal.vue?vue&type=style&index=0&id=2b931f17&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports